export function channelSelector() {
    const wrapper = document.querySelector('#channel-selector-dropdown');
    if (!wrapper)
        return;
    const button = wrapper.querySelector('#channel-selector-dropdown-btn');
    const menu = wrapper.querySelector('#channel-selector-dropdown-menu');
    if (!button || !menu)
        return;
    const close = () => {
        wrapper.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
    };
    const open = () => {
        wrapper.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
    };
    const toggle = () => {
        wrapper.classList.contains('is-open') ? close() : open();
    };
    button.addEventListener('click', toggle);
    button.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            close();
            button.focus();
        }
    });
    document.addEventListener('click', (e) => {
        if (!wrapper.contains(e.target))
            close();
    });
    wrapper.addEventListener('focusout', (e) => {
        if (!wrapper.contains(e.relatedTarget))
            close();
    });
    menu.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            close();
            button.focus();
        }
    });
}
